import { render } from "./Pencil.vue?vue&type=template&id=225ddd09"
import script from "./Pencil.vue?vue&type=script&lang=js"
export * from "./Pencil.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Pencil.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "225ddd09"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('225ddd09', __exports__)) {
    api.reload('225ddd09', __exports__)
  }
  
  module.hot.accept("./Pencil.vue?vue&type=template&id=225ddd09", () => {
    api.rerender('225ddd09', render)
  })

}


export default __exports__